<template>
	<div>
		<list-template :current-page="page" :loading="loading" :search-config="searchConfig" :table-config="tableConfig" :table-data="tableData" :total="total" @onBatchImport="handUpload" @onChange="onChange" @onChangePage="handleCurrentChange" @onExportData="handDownload" @onHandle="handleClick" @onSearch="onSearch" @onReset="onReset"></list-template>
		<Dialog :closeOnClickModal="false" :showCancelButton="false" :showFooter="true" :visible.sync="showImportDialog" buttonAlign="center" size="small" submitText="关闭" title="导入数据表">
			<LineWrapper labelColor="#222" labelWidth="100rem">
				<LineItem label="下载示例">
					<el-button icon="el-icon-download" size="small" type="primary" @click="handleDownFile(0)">点此下载</el-button>
				</LineItem>
				<LineItem label="下载模板">
					<el-button icon="el-icon-download" size="small" type="primary" @click="handleDownFile(1)">点此下载</el-button>
				</LineItem>
				<LineItem label="上传文件">
					<el-button icon="el-icon-upload2" size="small" @click="handleSelectFile">上传</el-button>
				</LineItem>
			</LineWrapper>
		</Dialog>
		<Dialog :beforeClose="onBeforeClose" :closeOnClickModal="false" :loading="dialogLoading" :showCancelButton="showCancelButton" :showFooter="true" :submitText="submitText" :title="title" :visible.sync="showDialog" buttonAlign="center">
			<LineWrapper class="list-box" column="2" label-width="130rem" list>
				<LineItem v-for="item in list" :key="item.label" :color="item.color" :cssStyle="item.cssStyle" :label="item.label" :value="item.value"></LineItem>
			</LineWrapper>
			<el-form v-if="showCancelButton" ref="form" :model="formData" :rules="rules" label-position="left" label-width="140rem">
				<el-form-item label="修改后金额" prop="money_answer_edit">
					<el-input v-model="formData.money_answer_edit" placeholder="请输入"></el-input>
				</el-form-item>
			</el-form>
		</Dialog>
	</div>
</template>

<script>
import { tableListMixin } from '@/utils/mixins'
import Dialog from '@/components/common/Dialog'
import LineItem from '@/components/common/LineItem'
import LineWrapper from '@/components/common/LineWrapper'
import { fileDownload, get_school2, zsGet, zsPost } from '@/api'
import { changeOption, handleChooseFile } from '@/utils'
import { validateNumber } from '@/utils/validate'
import ListTemplate from '@/components/pages/List.vue'

export default {
	_config: {
		route: { path: 'list', meta: { title: '列表', keepAlive: true } }
	},
	mixins: [tableListMixin],
	components: { ListTemplate, Dialog, LineItem, LineWrapper },
	data() {
		return {
			showImportDialog: false,
			showDialog: false,
			dialogLoading: false,
			title: '',
			submitText: '',
			showCancelButton: false,
			searchConfig: [
				{
					prop: 'pay_status',
					tag: 'select',
					placeholder: '筛选订单状态',
					options: []
				},
				{
					prop: 'school_id',
					tag: 'select',
					placeholder: '筛选就读学校',
					options: [],
					change: (val, search) => {
						setTimeout(() => {
							if (search.grade_id) search.grade_id = ''
							if (search.class_id) search.class_id = ''
							this.searchConfig[3].options = []
							this.getGrade(val)
							this.$forceUpdate()
						})
					}
				},
				{
					prop: 'grade_id',
					tag: 'select',
					placeholder: '筛选就读年级',
					options: [],
					change: (val, search) => {
						setTimeout(() => {
							if (search.class_id) search.class_id = ''
							if (search.school_id && val) {
								this.getClass({ grade_id: val, school_id: search.school_id })
							} else {
								this.searchConfig[3].options = []
							}
							this.$forceUpdate()
						})
					}
				},
				{
					prop: 'class_id',
					tag: 'select',
					placeholder: '筛选行政班',
					options: []
				},
				{ prop: 'school_year', tag: 'year', placeholder: '筛选缴费学年' },
				{
					prop: 'goods_pack_name',
					tag: 'searchSelect',
					placeholder: '搜索收费项名称',
					options: [],
					loading: false,
					remoteMethod: this.remoteGoodsMethod
				},
				{ prop: 'student_name', placeholder: '搜索学生姓名' }
			],
			tableConfig: [
				{ prop: 'pay_status_text', label: '订单状态' },
				{ prop: 'student_name', label: '学生姓名' },
				{ prop: 'student_no', label: '学号' },
				{ prop: 'goods_pack_name', label: '收费项名称' },
				{ prop: 'school_year', label: '缴费学年' },
				{ prop: 'grade', label: '就读年级' },
				{ prop: 'class_name', label: '行政班' },
				{ prop: 'teacher_name', label: '班主任' },
				{ prop: 'school', label: '就读校区' },
				{ prop: 'charge_at', label: '开始收费时间' },
				{ prop: 'money_answer', label: '应收金额' }
			],
			list: [],
			formData: { money_answer_edit: '', id: '' },
			rules: {
				money_answer_edit: [
					{
						required: true,
						validator: (_, value, callback) =>
							validateNumber(value, callback, {
								min: 0,
								max: 1000000,
								equalToMin: false,
								equalToMax: true
							}),
						trigger: 'change'
					}
				]
			}
		}
	},
	created() {
		this.getConfig()
	},
	methods: {
		onReset() {
			this.searchConfig[2].options = []
			this.searchConfig[3].options = []
			this.searchConfig[5].options = []
		},
		getConfig() {
			get_school2().then((res) => {
				this.searchConfig[1].options = changeOption({
					list: res,
					label: 'school_name',
					value: 'id'
				})
			})
			zsGet('/recruit-2024/renew/screen').then((res) => {
				const { pay_status_arr = [] } = res
				this.searchConfig[0].options = changeOption({
					list: pay_status_arr,
					label: 'pay_status_name',
					value: 'id'
				})
			})
		},
		getGrade(school_id) {
			if (!school_id) {
				this.searchConfig[2].options = []
				return
			}
			this.$_axios.get('/site/grades', { params: { school_id } }).then((res) => {
				const { data } = res.data
				this.searchConfig[2].options = changeOption({
					list: data || [],
					label: 'name',
					value: 'id'
				})
			})
		},
		getClass(params) {
			this.$_axios.get('/site/role-admin-class', { params }).then((res) => {
				const { data } = res.data
				this.searchConfig[3].options = changeOption({
					list: data || [],
					label: 'class_name',
					value: 'class_id'
				})
			})
		},
		/**
		 * @description 收费项名称远程搜索方法
		 * @param {string} query - 搜索关键词
		 * @returns {void}
		 */
		remoteGoodsMethod(query) {
			if (query !== '') {
				// 设置加载状态
				this.searchConfig[5].loading = true
				// 调用远程接口获取数据
				zsGet('/recruit-2024/other/screen', { keyword: query, is_edu: 1 })
					.then((res) => {
						// 将返回的数据转换为options格式
						this.searchConfig[5].options = changeOption({
							list: res || [],
							label: 'goods_pack_name',
							value: 'goods_pack_name'
						})
					})
					.finally(() => {
						// 关闭加载状态
						this.searchConfig[5].loading = false
					})
			} else {
				// 如果搜索关键词为空，清空选项
				this.searchConfig[5].options = []
			}
		},
		getData() {
			this.getDataApi('/zhaosheng/api/recruit/edu/student-order-list')
		},
		getDetail() {
			this.dialogLoading = true
			zsGet('/recruit-2024/other/detail', { id: this.formData.id })
				.then((res) => {
					this.formData.money_answer_edit = res.money_answer
					const arr = ['#F53F3F', '#23C343']
					const color = arr[res.pay_status] || '#9A9A9A'
					this.list = [
						{
							label: '订单状态',
							value: res.pay_status_name,
							cssStyle: { 'grid-column': '1 / -1' },
							color
						},
						{ label: '学生姓名', value: res.student_name },
						{ label: '学生身份证/护照号', value: res.student_idcard },
						{ label: '缴费学年', value: res.school_year },
						{ label: '入账学校', value: res.entry_school },
						{ label: '开始收费时间', value: res.charge_at },
						{ label: '收费项名称', value: res.goods_pack_name },
						{ label: '修改前金额', value: res.money_answer_front },
						{ label: '修改后金额', value: res.money_answer }
					]
				})
				.finally(() => (this.dialogLoading = false))
		},
		handleClick(row, handle) {
			const { type } = handle
			this.formData.id = row.id
			if (type === 'edit') {
				this.title = '编辑'
				this.submitText = '提交'
				this.showCancelButton = true
				this.rules.money_answer_edit[0].required = true
				const arr = ['#F53F3F', '#23C343']
				const color = arr[row.pay_status] || '#9A9A9A'
				this.list = [
					{
						label: '订单状态',
						value: row.pay_status_name,
						cssStyle: { 'grid-column': '1 / -1' },
						color
					},
					{ label: '学生姓名', value: row.student_name },
					{ label: '学生身份证/护照号', value: row.student_idcard },
					{ label: '缴费学年', value: row.school_year },
					{ label: '入账学校', value: row.entry_school },
					{ label: '开始收费时间', value: row.charge_at },
					{ label: '收费项名称', value: row.goods_pack_name },
					{ label: '修改前金额', value: row.money_answer_front }
				]
				this.showDialog = true
			} else if (type === 'view') {
				this.title = '查看'
				this.submitText = '关闭'
				this.showCancelButton = false
				this.rules.money_answer_edit[0].required = false
				this.getDetail()
				this.showDialog = true
			}
			if (type === 'delete') {
				if (Number(row.pay_status) === 1 || Number(row.pay_status) === 7) {
					this.$alert(`${Number(row.pay_status) === 1 ? '该订单已支付无法删除！' : '该订单已取消无法删除！'}`, {
						confirmButtonText: '确定',
						center: true
					}).then(() => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
					})
				} else {
					this.$confirm(`订单删除后需重新导入，请谨慎操作！`, {
						confirmButtonText: '确认删除',
						cancelButtonText: '取消',
						center: true
					}).then(() => {
						zsGet('/recruit-2024/other/delete', { id: row.id }, { loading: true }).then(() => {
							this.$message({
								type: 'success',
								message: '删除成功!'
							})
							this.getData()
						})
					})
				}
			}
		},
		initForm() {
			this.formData = { money_answer_edit: '', id: '' }
			this.list = []
		},
		onBeforeClose(done, instance) {
			const { type } = instance
			if (!this.showCancelButton || type !== 'submit') {
				done()
				this.initForm()
				return
			}
			this.$refs['form'].validate((valid) => {
				if (valid) {
					instance.confirmButtonLoading = true
					zsPost('/recruit-2024/other/update', { ...this.formData })
						.then(() => {
							this.showDialog = false
							this.getData()
							done()
							this.initForm()
							this.$message.success({ message: '操作成功', duration: 3000 })
						})
						.finally(() => {
							instance.confirmButtonLoading = false
						})
				}
			})
		},
		handUpload() {
			this.showImportDialog = true
		},
		handleSelectFile() {
			handleChooseFile({
				api: '/zhaosheng/api/recruit-2024/other/import',
				show: true,
				onSuccess: () => {
					this.showImportDialog = false
					this.$message.success({ message: '文件上传成功', duration: 5000 })
					this.getData()
				}
			})
		},
		handleDownFile(type) {
			const config = {
				name: `其他费用缴纳${type ? '模板' : '示例'}`,
				type: 'xlsx'
			}
			const api = `${process.env.VUE_APP_URL_OSS}other-fees-paid/${type ? 'template' : 'dome'}.xlsx`
			fileDownload(api, {}, config).then((res) => {
				this.showImportDialog = false
			})
		},
		handDownload() {
			fileDownload('/zhaosheng/api/recruit/edu/student-order-export', { ...this.search }, { name: '学生缴费情况', show: true })
		}
	}
}
</script>

<style lang="scss" scoped>
// .list-box {
//   display: grid;
//   gap: 10rem 20rem;
//   grid-template-columns: repeat(auto-fill, minmax(200rem, 1fr));
// }
</style>
